// src/pages/Login.js
import { useState, useEffect, useRef } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import "./Login.css";
import { useNavigate } from "react-router-dom";

export default function Login({ setOtpVerified }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [otpStage, setOtpStage] = useState(false);
  const [loading, setLoading] = useState(false);

  const canvasRef = useRef(null);
  const navigate = useNavigate();

  const API_BASE =
    "https://us-central1-anonymous-complaint-portal.cloudfunctions.net/poini";

  /* ── starfield ── */
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let raf;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const stars = Array.from({ length: 200 }, () => ({
      x: Math.random(),
      y: Math.random(),
      r: Math.random() * 1.5,
    }));

    const draw = () => {
      ctx.fillStyle = "#030510";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      stars.forEach((s) => {
        ctx.beginPath();
        ctx.arc(s.x * canvas.width, s.y * canvas.height, s.r, 0, Math.PI * 2);
        ctx.fillStyle = "#cfe2ff";
        ctx.fill();
      });
      raf = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  /* ── login + send otp ── */
  const handleLogin = async () => {
    if (!email || !password) {
      alert("Enter email and password");
      return;
    }
    try {
      setLoading(true);
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const res = await fetch(`${API_BASE}/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid: cred.user.uid, email: cred.user.email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setOtpStage(true);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  /* ── verify otp ── */
  const handleVerifyOTP = async () => {
    if (otp.length !== 6) {
      alert("Enter valid 6-digit OTP");
      return;
    }
    try {
      setLoading(true);
      const user = auth.currentUser;
      if (!user) {
        alert("Session expired. Login again.");
        setOtpStage(false);
        return;
      }
      const res = await fetch(`${API_BASE}/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid: user.uid, otp }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setOtpVerified(true);
      localStorage.setItem("otpVerified", "true");
      navigate("/dashboard");
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  /* ── resend ── */
  const resendOTP = async () => {
    const user = auth.currentUser;
    if (!user) return;
    try {
      await fetch(`${API_BASE}/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid: user.uid, email: user.email }),
      });
      alert("OTP resent");
    } catch {
      alert("Failed to resend OTP");
    }
  };

  /* ── ui ── */
  return (
    <>
      <canvas ref={canvasRef} className="space-canvas" />

      <div className="login-container">
        {/* <div className="login-seal">EC</div> */}

        <h2>ΠΟΙΝΗ</h2>
        <h4>Penalty Management System</h4>

        <div className="login-divider" />

        {!otpStage ? (
          <>
            <input
              type="email"
              placeholder="IITK EMAIL ID"
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="PASSWORD"
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleLogin()}
            />
            <button onClick={handleLogin} disabled={loading}>
              {loading ? "Please wait…" : "Login"}
            </button>
          </>
        ) : (
          <>
            <input
              className="otp-input"
              type="text"
              maxLength={6}
              placeholder="······"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
              onKeyDown={(e) => e.key === "Enter" && handleVerifyOTP()}
            />
            <button onClick={handleVerifyOTP} disabled={loading}>
              {loading ? "Verifying…" : "Verify OTP"}
            </button>
            <p
              style={{
                marginTop: 14,
                fontSize: 12,
                color: "rgba(255,255,255,0.35)",
                cursor: "pointer",
                fontFamily: "'JetBrains Mono', monospace",
              }}
              onClick={resendOTP}
            >
              Didn't receive OTP? Resend
            </p>
          </>
        )}

        <div className="login-footer">Election Commission · IIT Kanpur</div>
      </div>
    </>
  );
}
